<template>
  <div class="popup"
       :class="{ 'is-visible': visible  }"
  >
    <transition name="vue-animation-fade"
                :appear="animationOnMount">
      <div v-if="contentVisible"
           class="popup__cont">
        <div class="popup__close btn btn--circle"
             v-if="showCloseIcon"
             @click="closeHandler">
          <vue-icon type="closeCircle"
                    :animation-after-mount="!animationOnMount" />
        </div>
        <!--TITLE-->
        <h2 v-if="showTitle"
            class="popup__title">
          <slot name="title">{{ title }}</slot>
        </h2>
        <!--CONTENT-->
        <slot :closeHandlerFn="closeHandler" />
      </div>
    </transition>
  </div>
</template>

<script lang="js">
export default {
  name: 'vue-popup',

  props: {
    animationOnMount: {
      type: Boolean,
      required: false,
      default: true
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    showTitle: {
      type: Boolean,
      required: false,
      default: true
    },
    showCloseIcon: {
      type: Boolean,
      required: false,
      default: true
    },
    visible: {
      type: Boolean,
      required: false,
      default: false
    },
    closeable: {
      type: Boolean,
      required: false,
      default: true
    },
    closeHandlerFn: {
      type: Function,
      required: false,
      default: () => ({ id }) => undefined
    }
  },

  methods: {
    async closeHandler() {
      if ( !this.closeable ) {
        return;
      }

      this.$emit('close');
      this.$emit('update:visible', false);
      this.closeHandlerFn({ id: this.$el.id });
    }
  },

  data() {
    return {
      contentVisible: false
    };
  },

  watch: {
    visible: {
      immediate: false,
      handler(val) {
        if ( val ) window.setTimeout(() => this.contentVisible = true, 200);
        if ( !val ) this.contentVisible = false;
      }
    }
  },
  created() {
    const handler = e => {
      if ( e.keyCode === 27 ) {
        this.closeHandler();
      }
    };

    window.document.addEventListener('keyup', handler);

    this.$on('hook:beforeDestroy', () => {
      window.document.removeEventListener('keyup', handler);
    });
  },
  mounted() {
    window.setTimeout(
      () => this.contentVisible = true,
      200
    );
  }
};
</script>

<style scoped>
.vue-animation-fade-enter, .vue-animation-fade-leave-to {
  opacity: 0;
  transform: translateY(-100vh);
}

.vue-animation-fade-enter-to {
  opacity: 1;
  transform: rotateY(0);
}

.vue-animation-fade-enter-active {
  transition: all 1s 0.2s ease;
}
</style>
